module.exports = __webpack_public_path__ + "assets/img/apple-store.faa57e7f.png";